import React from "react";
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
//import { LocalizationProvider } from '@mui/x-date-pickers';
//import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import theme from './theme';
import Main from './Main';
import './css/maps.css';
import './css/dropdown.css';
import './css/modal.css';
import './css/imageGallery.css'

function App() {
  const mode = 'deploy'	// ***** 'dev' for development; change to 'deploy' for operational *****

  return (
    <div>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter basename="/vt">
          <Main 
            mode={mode}
          />
        </BrowserRouter>
		  </ThemeProvider>
    </div>
  );
}

export default App;
